module.exports = global["Tether"] = require("-!/home/victor/Téléchargements/kids/_dev/node_modules/babel-loader/index.js!./tether.js");


//////////////////
// WEBPACK FOOTER
// ./~/expose-loader?Tether!./~/tether/dist/js/tether.js-exposed
// module id = 27
// module chunks = 0